/* ============================================================
   Advanced Look Finder — JS (filtro nativo a faccette, AND sui metafield)
   Ogni filtro selezionato diventa un parametro nativo Shopify
   filter.p.m.custom.<key>=<valore> su una collezione.
   - Chiavi diverse (categorie diverse) => AND  (es. colore=rosa E taglia=2a).
   - 1 categoria scelta => tutti i prodotti con quel valore.
   - 2+ categorie => solo i prodotti che le hanno TUTTE.
   Filtra solo i prodotti che hanno i metafield valorizzati (i prodotti senza
   quel valore non compaiono, come richiesto).
   Requisiti negozio: metafield custom.* popolati sui prodotti + quei metafield
   abilitati come Filtri in Search & Discovery. Nessuna libreria.
   ============================================================ */
(function () {
  "use strict";
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function initForm(form) {
    var section = form.closest(".scm-finder");
    if (!section) return;
    var targetCollection = (section.getAttribute("data-target") || "").trim();
    var searchPath = section.getAttribute("data-search-path") || "/search";
    // Collezione su cui applicare i filtri: quella impostata, altrimenti tutto il catalogo.
    var collection = targetCollection !== "" ? targetCollection : "all";

    // particelle decorative
    var sparkWrap = section.querySelector(".scm-finder__sparkles");
    if (sparkWrap && !reduce && !sparkWrap.childElementCount) {
      for (var i = 0; i < 22; i++) {
        var sp = document.createElement("span");
        sp.className = "scm-sp";
        var size = (Math.random() * 4 + 2).toFixed(1);
        sp.style.width = sp.style.height = size + "px";
        sp.style.left = (Math.random() * 100).toFixed(1) + "%";
        sp.style.top = (Math.random() * 100).toFixed(1) + "%";
        sp.style.animationDelay = (Math.random() * 4).toFixed(1) + "s";
        sp.style.animationDuration = (Math.random() * 3 + 3).toFixed(1) + "s";
        sparkWrap.appendChild(sp);
      }
    }

    form.addEventListener("submit", function (e) {
      e.preventDefault();

      // Ricerca libera (opzionale)
      var q = "";
      var qInput = form.querySelector('input[name="q"]');
      if (qInput) q = qInput.value.trim();

      // Filtri metafield nativi: un parametro per categoria selezionata (AND tra categorie)
      var metaParams = [];
      form.querySelectorAll("select").forEach(function (sel) {
        if (!sel.value) return;
        var key = (sel.getAttribute("data-filter-key") || "").trim();
        if (key) metaParams.push({ key: key, value: sel.value });
      });

      // Flag (es. "Solo nuova collezione") => filtro metafield booleano (valore 1)
      form.querySelectorAll(".scm-finder__flag-input").forEach(function (cb) {
        if (!cb.checked) return;
        var fkey = (cb.getAttribute("data-flag-key") || "").trim();
        var fval = (cb.getAttribute("data-flag-value") || "1").trim();
        if (fkey) metaParams.push({ key: fkey, value: fval === "true" ? "1" : fval });
      });

      if (metaParams.length > 0) {
        // Filtro mirato a faccette sulla collezione (AND nativo Shopify).
        var params = new URLSearchParams();
        metaParams.forEach(function (f) { params.append(f.key, f.value); });
        window.location.href = "/collections/" + collection + "?" + params.toString();
      } else if (q !== "") {
        // Solo testo libero, nessuna categoria: ricerca standard.
        window.location.href = searchPath + "?q=" + encodeURIComponent(q) + "&type=product";
      } else {
        // Niente selezionato: mostra il catalogo della collezione.
        window.location.href = "/collections/" + collection;
      }
    });
  }

  function boot() {
    document.querySelectorAll('[id^="scm-finder-form-"]').forEach(initForm);
  }
  if (document.readyState !== "loading") boot();
  else document.addEventListener("DOMContentLoaded", boot);
  document.addEventListener("shopify:section:load", boot);
})();
